<template>
  <div class="import-history">
    <div class='page-title'>
      导入记录
    </div>
    <div class="page-table">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="calc(100% - 50px)"
      >
        <el-table-column
          prop="fileName"
          label="文件名称"
          align="center"
        >
        <template slot-scope="scopes">
          <Debounce :time="3000" :isDebounce="3">
            <span
              style="color: #1890ff; margin-right: 10px; cursor: pointer"
              @click="downLoad(scopes.row)"
              >{{scopes.row.fileName}}</span
            >
          </Debounce>
        </template>
        </el-table-column>
        <el-table-column
          prop="uploadStatus"
          label="导入状态"
          align="center"
        >
        <template slot-scope="scopes">
          {{ uploadStatusList[+scopes.row.uploadStatus - 1] }}
        </template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <span
              v-show="scope.row.uploadStatus == 3 || scope.row.uploadStatus == 4"
              style="color: #1890ff; margin-right: 10px; cursor: pointer"
              @click="showFail(scope.row)"
              >查看失败记录</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 查看失败记录弹框 -->
    <el-dialog
      title="失败记录"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="50%"
    >
    <failTemp :failItem='failItem'/>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import failTemp from './components/failDialog.vue'
import {
  getImportHistoryList
} from '@api/corporateInteraction/enterprise'
export default {
  name: 'EntImportHistory',
  components: {
    failTemp
  },
  data() {
    return {
      tableData: [],
      pageNum: 1,
      uploadStatusList: ['导入中', '导入成功', '导入失败', '导入报错'],
      pageSize: 10,
      totalRecord: 0,
      dialogVisible: false,
      failItem: {}
    }
  },
  created() {
    this.getHistory()
  },
  methods: {
    showFail(item) {
      this.failItem = item
      this.dialogVisible = true
    },
    downLoad(item) {
      window.open(item.ossUrl)
    },
    getHistory() {
      console.log(123)
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getImportHistoryList(params).then(res => {
        console.log(res, 'res')
        const { data, code } = res.data
        if (code === '0000') {
          this.tableData = data.results || []
          this.totalRecord = data.totalRecord || 0
        }
      })
    },
    //  表格翻页
    handleCurrentChange(pageNum, e) {
      this.pageNum = pageNum
      this.getHistory()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getHistory()
    }
  }
}
</script>

<style lang="scss" scoped>
.import-history{
  width: 100%;
  height: 100%;
  background-color: white;
  /deep/.el-dialog__body{
    padding:10px 20px 20px;
  }
  .page-title{
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    padding: 0 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.85);
  }
  .page-table{
    padding: 24px;
    overflow: hidden;
    height: calc(100% - 60px);
    .table-page{
      margin-top: 20px;
      /deep/.el-pagination{
        float: right;
      }
    }
  }
}
</style>
